export const isAutoscaleType = type =>
  ["autoscale.horizontal.down", "autoscale.horizontal.up"].includes(type);
